import type { EurekaPackageType } from '@eureka/services/src/apis/common.api.types';
import type { EActivityTriggerType } from '@eureka/services/src/types/activity-type';

export interface IOpenClueReportOptions {
    version: string;
    sourceType?: EActivityTriggerType;
    packageType: EurekaPackageType;
    hubspotPortalId?: string;
    hubspotFormId?: string;
    trackParams?: Record<string, any>;
    onClose?: () => void;
}

export enum E_LanguageLong {
    en = 'en_US',
    cn = 'zh_CN',
    tw = 'zh_TW',
    jp = 'ja_JP'
}
